import React from 'react';

export default function En() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path fill="#F0F0F0" d="M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18" />
      <path
        fill="#D80027"
        d="M8.608 9H18c0 -0.812 -0.109 -1.6 -0.31 -2.348H8.608zm0 -4.695h8.07a9 9 0 0 0 -2.076 -2.348H8.608zM9 18.001a8.96 8.96 0 0 0 5.602 -1.956H3.397A8.96 8.96 0 0 0 9 18Zm-7.679 -4.306h15.358a9 9 0 0 0 1.011 -2.347H0.31a9 9 0 0 0 1.011 2.347"
      />
      <path
        fill="#0052B4"
        d="M4.169 1.405h0.82l-0.763 0.555 0.292 0.897 -0.763 -0.555 -0.763 0.555 0.252 -0.775a9 9 0 0 0 -1.746 1.945h0.263l-0.486 0.353a9 9 0 0 0 -0.217 0.385l0.231 0.713 -0.432 -0.314q-0.162 0.341 -0.295 0.699l0.256 0.786h0.943l-0.763 0.554 0.291 0.897 -0.762 -0.554 -0.457 0.332Q0 8.429 0 9h9V0a8.96 8.96 0 0 0 -4.831 1.405M4.518 8.1l-0.763 -0.554 -0.763 0.554 0.291 -0.897 -0.763 -0.554h0.943l0.292 -0.897 0.291 0.897h0.943l-0.763 0.554zm-0.292 -3.519 0.292 0.897 -0.763 -0.554 -0.763 0.554 0.291 -0.897 -0.763 -0.554h0.943l0.292 -0.897 0.291 0.897h0.943zM7.746 8.1l-0.763 -0.554 -0.763 0.554 0.292 -0.897 -0.763 -0.554h0.943l0.291 -0.897 0.291 0.897h0.943l-0.763 0.554zm-0.292 -3.519 0.292 0.897 -0.763 -0.554 -0.763 0.554 0.292 -0.897 -0.763 -0.554h0.943l0.291 -0.897 0.291 0.897h0.943zm0 -2.621 0.292 0.897 -0.763 -0.555 -0.763 0.555 0.292 -0.897 -0.763 -0.555h0.943L6.983 0.51l0.291 0.896h0.943l-0.763 0.555Z"
      />
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
